exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-travel-filter-editor {\n  padding: 24px;\n  background-color: white;\n}\n@media (max-width: 576px) {\n  .dyna-travel-filter-editor {\n    padding: 8px;\n  }\n}\n.dyna-travel-filter-editor__button-bar {\n  margin-bottom: 24px;\n}\n.dyna-travel-filter-editor .dyna-filter-input {\n  margin-bottom: 18px;\n}\n.dyna-travel-filter-editor .dyna-slider-label {\n  font-size: 17px;\n  font-weight: bold;\n}\n.dyna-travel-filter-editor .dyna-slider-value {\n  font-weight: bold;\n}\n.dyna-travel-filter-editor .dyna-slider-daylight {\n  opacity: 0.3;\n}\n", ""]);

// exports
